// Types of actions

// Set value in storage
export const SET_VALUE_IN_STORAGE = "SET_VALUE_IN_STORAGE"
export const SET_MULTIPLE_VALUES_IN_STORAGE = "SET_MULTIPLE_VALUES_IN_STORAGE"

// Other Databases
// Historic Results
export const PUSH_ANNOTATION_RESULT = "PUSH_ANNOTATION_RESULT"

